module.exports = __webpack_public_path__ + "static/media/1.e4a9d0c8.jpg";